import React from 'react';
import { ClassAssembly4B2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly4B2026/>;
  };
  
  export default ClassAssemblyPage;